module.exports = __webpack_public_path__ + "img/directbox-send.34a69866.svg";